import "../../../styles/stores/stockManagement/sizeWishes.css";

import EachSizeOrColorSelected from "./EachSizeOrColorSelected";
import { useState, useEffect, useLayoutEffect } from "react";
import { BsArrowDownShort } from "react-icons/bs";
import { IoClose } from "react-icons/io5";

/* disregard the term "training" that was used here.  */

export const colors = [
  { id: Math.random() * 1000 + "red", name: "red" },
  { id: Math.random() * 1000 + "blue", name: "blue" },
  { id: Math.random() * 1000 + "green", name: "green" },
  { id: Math.random() * 1000 + "yellow", name: "yellow" },
  { id: Math.random() * 1000 + "orange", name: "orange" },
  { id: Math.random() * 1000 + "purple", name: "purple" },
  { id: Math.random() * 1000 + "pink", name: "pink" },
  { id: Math.random() * 1000 + "brown", name: "brown" },
  { id: Math.random() * 1000 + "black", name: "black" },
  { id: Math.random() * 1000 + "white", name: "white" },
  { id: Math.random() * 1000 + "grey", name: "grey" },
  { id: Math.random() * 1000 + "gold", name: "gold" },
  { id: Math.random() * 1000 + "silver", name: "silver" },
  { id: Math.random() * 1000 + "maroon", name: "maroon" },
  { id: Math.random() * 1000 + "navy", name: "navy" },
  { id: Math.random() * 1000 + "teal", name: "teal" },
  { id: Math.random() * 1000 + "lime", name: "lime" },
  { id: Math.random() * 1000 + "aqua", name: "aqua" },
  { id: Math.random() * 1000 + "olive", name: "olive" },
  { id: Math.random() * 1000 + "cyan", name: "cyan" },
  { id: Math.random() * 1000 + "indigo", name: "indigo" },
  { id: Math.random() * 1000 + "violet", name: "violet" },
  { id: Math.random() * 1000 + "magenta", name: "magenta" },
  { id: Math.random() * 1000 + "beige", name: "beige" },
  { id: Math.random() * 1000 + "azure", name: "azure" },
  { id: Math.random() * 1000 + "mint", name: "mint" },
  { id: Math.random() * 1000 + "coral", name: "coral" },
  { id: Math.random() * 1000 + "salmon", name: "salmon" },
  { id: Math.random() * 1000 + "khaki", name: "khaki" },
  { id: Math.random() * 1000 + "lavender", name: "lavender" },
  { id: Math.random() * 1000 + "crimson", name: "crimson" },
  { id: Math.random() * 1000 + "fuchsia", name: "fuchsia" },
  { id: Math.random() * 1000 + "tan", name: "tan" },
  { id: Math.random() * 1000 + "orchid", name: "orchid" },
  { id: Math.random() * 1000 + "plum", name: "plum" },
  { id: Math.random() * 1000 + "salmon", name: "salmon" },
];

const WisheColor = ({ updateSelectedColor, closeModalWithColorTrue, closeModalWithColorFalse }) => {
  const [selectedColor, setSelectedColor] = useState([]);
  const [openDropDown, setOpenDropDown] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    if (selectedColor.length > 0) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [selectedColor]);

  const toggleDropDown = () => {
    openDropDown ? setOpenDropDown(false) : setOpenDropDown(true);
  };

  const addSelectedColor = (colorChoose) => {
    let match = selectedColor.find((color) => color.id === colorChoose.id);
    if (!match && selectedColor.length < 6) {
      setSelectedColor([...selectedColor, colorChoose]);
    }
  };

  const removeSelectedColor = (colorChoose) => {
    let filteredColor = selectedColor.filter((color) => colorChoose.id !== color.id);
    setSelectedColor(filteredColor);
  };
  const submitSelectedColor = () => {
    updateSelectedColor(selectedColor);
    closeModalWithColorTrue(false);
  };

  return (
    <>
      <div onClick={() => closeModalWithColorFalse(false)} className='wishesListWrapper'>
        <div onClick={(e) => e.stopPropagation()} className='wishesWrapper994'>
          <div onClick={() => toggleDropDown()} className='selectTrainingsDropDown'>
            <p>Select six colors which are available</p>
            {openDropDown ? (
              <span className='closeDropDownSpan'>
                <IoClose />{" "}
              </span>
            ) : (
              <BsArrowDownShort size={20} />
            )}
            {openDropDown && (
              <div className='dropDownMenu12'>
                {colors.map((color, i) => (
                  <div
                    key={i}
                    onClick={(e) => {
                      addSelectedColor(color);
                      //e.stopPropagation();
                    }}
                    className='flexColorDiv22'
                  >
                    <span style={{ backgroundColor: `${color.name}` }}></span>
                    <p> {color.name} </p>
                  </div>
                ))}
              </div>
            )}
          </div>
          {selectedColor.length > 0 && (
            <div className='selectedTrainingsDIv'>
              {/* training means color */}
              {selectedColor.map((color, i) => (
                <EachSizeOrColorSelected key={i} training={color} deleteTraining={removeSelectedColor} />
              ))}
            </div>
          )}

          <div className='SubmitSelection123'>
            {isFormValid ? (
              <button onClick={submitSelectedColor}>Submit colors</button>
            ) : (
              <button style={{ cursor: "not-allowed", backgroundColor: "white", opacity: "0.6" }} disabled>
                Submit colors
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default WisheColor;
